import gql from "graphql-tag";

import { FRAGMENT_USER_ALL_FIELDS } from "../../../graphql/gqlFragments";

export const SIGN_OUT = gql`
  mutation signOut {
    signOut {
      status
    }
  }
`;

export const UPDATE_USER_AVATAR = gql`
  mutation updateUserAvatar($avatar: Upload!, $cropParams: CropParamsInput) {
    updateUserAvatar(avatar: $avatar, cropParams: $cropParams) {
      avatar
    }
  }
`;

export const UPDATE_USER_PROFILE_INFO = gql`
  mutation updateProfile(
    $firstName: String
    $lastName: String
    $aboutMe: String # $buyerLocation: LocationInput
    $tcpaAccepted: Boolean
  ) {
    updateProfile(
      firstName: $firstName
      lastName: $lastName
      aboutMe: $aboutMe # buyerLocation: $buyerLocation
      tcpaAccepted: $tcpaAccepted
    ) {
      user {
        id
        firstName
        lastName
        aboutMe
        tcpaAccepted
        buyerLocation {
          id
          description
          placeId
        }
      }
    }
  }
`;

export const FILTERS_LIST = gql`
  query getFiltersList {
    filters {
      price {
        tagId
        title
        description
        icon
        values
        propertyField
        type
      }
      entities {
        tagId
        title
        description
        icon
        values
        propertyField
        type
      }
    }
  }
`;

export const PLACES_SUGGESTIONS = gql`
  query GetSuggestions($address: String!) {
    places(input: $address) {
      type
      places {
        description
        placeId
      }
    }
  }
`;

export const USER_TAGS = gql`
  mutation userTags($filters: [SearchHash!]!) {
    userTags(filters: $filters) {
      entities {
        tagId
        title
        icon
        value
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser {
    deleteUser {
      status
    }
  }
`;

export const BUYER_PROFILE = gql`
  query buyerProfile($id: ID!) {
    buyerProfile(id: $id) {
      userInfo {
        id
        firstName
        lastName
        phone
        email
        role
        avatar
        background
        leadType
        leadPrice
        status
        aboutMe
      }
      recommendedHomes {
        links {
          link
        }
        files {
          fileName
          file
          location
          price
          status
        }
      }
      preferences {
        propertyType {
          id
          title
        }
        propertyTypes {
          id
          title
        }
        textPreferences {
          category {
            id
            title
          }
          entities {
            tagId
            title
            value
            icon
            tagFilterType
          }
        }
        imagePreferences {
          tagId
          title
          value
          # icon
          image
        }
      }
    }
  }
`;

export const EDIT_PREFERENCES = gql`
  query editPreferences($categoryId: ID!) {
    editPreferences(categoryId: $categoryId) {
      title
      entities {
        tagId
        title
        description
        icon
        values
        propertyField
        type
        needAnyValue
        selectedValue
      }
    }
  }
`;

export const UPDATE_BUYER_PREFERENCES = gql`
  mutation updateBuyerPreferences($filters: [SearchHash!]!, $categoryId: ID!) {
    updateBuyerPreferences(filters: $filters, categoryId: $categoryId) {
      entities {
        tagId
        title
        icon
        value
        tagFilterType
      }
    }
  }
`;

export const EDIT_IMAGE_PREFERENCES = gql`
  query editImagePreference($tagId: ID!) {
    editImagePreference(tagId: $tagId) {
      tagId
      title
      description
      icon
      values {
        value
        image
      }
      type
      needAnyValue
      selectedValue
    }
  }
`;

export const UPDATE_BUYER_IMAGE_PREFERENCES = gql`
  mutation updateBuyerImagePreference($value: String!, $tagId: ID!) {
    updateBuyerImagePreference(value: $value, tagId: $tagId) {
      entity {
        tagId
        title
        image
        value
      }
    }
  }
`;

export const REFUSE_TO_BE_LEAD = gql`
  mutation refuseToBeLead($value: Boolean!) {
    refuseToBeLead(value: $value) {
      value
    }
  }
`;

export const INTERESTING_PROPERTIES = gql`
  query interestingProperties($userId: ID!, $page: Int, $perPage: Int) {
    interestingProperties(userId: $userId, page: $page, perPage: $perPage) {
      entities {
        id
        listPrice
        onMarket
        gAddress
        bedrooms
        bathsFull
        street
        city
        isInteresting
        source
        status
        fullAddress
        daysOnMarket
        livingArea
        likelihoodToSellDescription
        photos {
          id
          image
          preview2x
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
    }
  }
`;

export const CLAIMED_PROPERTIES = gql`
  query claimedProperties($userId: ID, $page: Int, $perPage: Int) {
    claimedProperties(userId: $userId, page: $page, perPage: $perPage) {
      entities {
        status
        updatedAt
        property {
          id
          listPrice
          onMarket
          gAddress
          bedrooms
          # bathrooms
          bathsFull
          street
          city
          source
          status
          fullAddress
          daysOnMarket
          livingArea
          likelihoodToSellDescription
          photos {
            id
            image
            preview2x
          }
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
    }
  }
`;

export const GET_SUGGESTIONS = gql`
  query GetSuggestions($address: String!) {
    places(input: $address) {
      type
      places {
        description
        type
        placeId
        mainText
        secondaryText
      }
    }
  }
`;

export const GET_ADDRESSES = gql`
  query addresses($input: String!) {
    addresses(input: $input) {
      type
      places {
        description
        type
        placeId
        mainText
        secondaryText
      }
    }
  }
`;

export const GET_USER = gql`
  query getUser {
    getUser {
      ...UserAllFields
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const GENERATE_BUYER_PDF = gql`
  mutation generateBuyerProfilePdf($buyerId: ID!) {
    generateBuyerProfilePdf(buyerId: $buyerId) {
      status
    }
  }
`;
